import { render, staticRenderFns } from "./ProjectsDashboard.vue?vue&type=template&id=21fa79ad&scoped=true&"
import script from "./ProjectsDashboard.vue?vue&type=script&lang=js&"
export * from "./ProjectsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsDashboard.vue?vue&type=style&index=0&id=21fa79ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fa79ad",
  null
  
)

export default component.exports